<script lang="ts" setup>
import FooterCopyright from './FooterCopyright.vue'
import FooterMenu from './FooterMenu.vue'

defineOptions({
  name: 'AppFooter',
})

</script>

<template>
  <div class="app-footer">
    <div class="app-footer__container">
      <FooterCopyright class="desktop" />
      <FooterMenu />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AppFooter.scss" />